import React from "react";
import ReactDOM from 'react-dom';
const PanelPortal = ({ children }) => ReactDOM.createPortal(children, document.body);
const Dropdown = ({ selectedItem, items, getItemId, getItemTitle, onSelectItem }) => {
    const [isOpen, setIsOpen] = React.useState(false);
    const rootRef = React.useRef(null);
    const panelRef = React.useRef(null);
    const clickMain = React.useCallback(() => {
        setIsOpen(open => !open);
    }, [setIsOpen]);
    const clickItem = React.useCallback((item) => {
        onSelectItem(item);
        setIsOpen(false);
    }, [onSelectItem]);
    React.useEffect(() => {
        if (!(rootRef.current && panelRef.current))
            return undefined;
        const fixPanel = () => {
            const rootBounds = rootRef.current.getBoundingClientRect();
            const scrollTop = window.pageYOffset ||
                window.document.documentElement.scrollTop ||
                window.document.body.scrollTop ||
                0;
            jQuery(panelRef.current).css({
                left: rootBounds.left,
                top: rootBounds.bottom + scrollTop,
                width: rootBounds.width,
            });
        };
        window.addEventListener('resize', fixPanel, { passive: true });
        fixPanel();
        return () => {
            window.removeEventListener('resize', fixPanel);
        };
    }, [rootRef.current, panelRef.current]);
    React.useEffect(() => {
        if (!(isOpen && rootRef.current && panelRef.current))
            return undefined;
        const handleClick = (event) => {
            if (!rootRef.current.contains(event.target) &&
                !panelRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('click', handleClick, { passive: false });
        return () => {
            document.removeEventListener('click', handleClick);
        };
    }, [isOpen, rootRef.current, panelRef.current]);
    const resultItems = items.map((item, index) => {
        return (React.createElement("div", { key: getItemId(item, index), className: "wm-dropdown__title", onClick: () => clickItem(item) },
            React.createElement("span", null, getItemTitle(item))));
    });
    const dropdownClasses = ['wm-dropdown'];
    const dropdownPanelClasses = ['wm-dropdown__panel'];
    if (isOpen) {
        dropdownClasses.push('-dOpen');
        dropdownPanelClasses.push('-dOpen');
    }
    return (React.createElement("div", { className: dropdownClasses.join(' '), ref: rootRef },
        React.createElement("div", { onClick: clickMain, className: "wm-dropdown__selectedTitle wm-dropdown__title" },
            React.createElement("span", null, getItemTitle(selectedItem)),
            React.createElement("i", { className: "fas fa-chevron-down" })),
        React.createElement(PanelPortal, null,
            React.createElement("div", { className: dropdownPanelClasses.join(' '), ref: panelRef }, resultItems))));
};
export default Dropdown;
